<template>
  <div class="box13">
    <pageTitle title="常见问题" titleColor="#191c47" />

    <commomProblem
      class="box"
      :problemData="problemData"
      :styleData="styleData"
    />
    <div class="btn" @click="zixun('其他问题 咨询老师')">其他问题 咨询老师</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "企业为什么会需要产品经理？",
          answer: [
            "老板创业以后更多的关注财务、商业运作以及公司战略方向，需要有专人来设计产品。而且公司开发时间成本和试错成本太高，需要有人快速及有效的设计方案指导团队开发项目。",
          ],
        },
        {
          title: "产品经理具体工作是什么？",
          answer: [
            "需求收集及分析、撰写文档、绘制原型、评审和研发排期、产品验收、产品上线、产品更新迭代。",
          ],
        },
        {
          title:
            "产品经理难的是哪一部分？ 做好产品经理关键的是要掌握哪一块的内容？",
          answer: [
            "刚入行的难点，应该是需求分析，怎么将需求转化成功能；逻辑思维能力和判断力是很关键的，还是要多思考、多实战，在实战中不断的学习和进步。",
          ],
        },
        {
          title:
            "我的自主学习力差有没有人监督和指导？我毕业之后能不能找到工作……",
          answer: [
            "以上这些担心大可不必，博学谷的教学服务是全方位的！随到随学、专属学习计划、定制学习方案，学习期间随时答疑，就业老师指导服务，助你顺利拿到高薪offer！你只要按照老师帮你制定的学习计划和学习方法去学习就够了！其余的就交给老师们吧！",
          ],
        },
        {
          title: "如何保障我的就业？",
          answer: [
            "一站式流程就业服务，就业指导老师进行简历指导+模拟面试+技术导师项目指导，并通过就业课程，分享学习方法、求职经验等，让你实时了解行业动态，助你高薪就业。",
          ],
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/pm/box13/icon.png"),
      },
    };
  },
  methods: {
    zixun(name) {
       this.mai("产品经理-就业课","其他问题 咨询老师",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box13 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/java/box11/bgc.png") no-repeat;
  background-size: cover;
  .box {
    margin-top: 48px;
  }
  .btn {
    margin: 0 auto;
    margin-top: 48px;
    width: 690px;
    height: 96px;
    background-image: linear-gradient(90deg, #3363fc 0%, #9b97ff 100%);
    box-shadow: 0px 0px 20px 0px #e6eef5;
    border-radius: 48px;
    text-align: center;
    font-size: 30px;
    line-height: 96px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
